import { Select } from "antd";
import { FormComponentProps } from 'antd/lib/form';
import { SelectValue } from 'antd/lib/select';
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { IOfficer } from "src/services/interfaces/IOfficer";
import { ServiceContext } from "src/services/provider/Service.provider";
import { PbrSelect } from "../PbrSelect/PbrSelect";
import { ShowNotification } from "../ShowNotification/ShowNotification";

export default interface ISelectOfficer extends FormComponentProps {
  handleChange: (value: SelectValue) => void;
  value: any;
  label: string;
  disabled?: boolean;
  isRequired?: boolean;
}

export const SelectOfficer: React.FC<ISelectOfficer> = ({ handleChange, value, label, disabled, isRequired, form }) => {

  const { officerService } = useContext(ServiceContext);

  const [officers, setOfficers] = useState<IOfficer[]>([]);

  useEffect(() => {
    getOfficers();
  }, []);

  function getOfficers() {
    officerService
      .getAll()
      .then(setOfficers)
      .catch(() => ShowNotification.Error("Não foi possível carregar a lista de officers.", "Erro ao obter informações"));
  }

  return (
    <PbrSelect
      name="officer"
      size="large"
      formItemProps={{ label }}
      showSearch
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder="Selecione o Officer"
      formWrapper={form}
      rules={[
        {
          required: isRequired,
          message: "Selecione o Officer"
        }
      ]}
    >
      {officers.length === 0 && (
        <Select.Option value="">
          Carregando...
        </Select.Option>
      )}
      {officers.length !== 0 && (
        <Select.Option value="">
          Selecione o Officer
        </Select.Option>
      )}
      {officers.map(({ id, name }) => (
        <Select.Option key={`${id}`} value={id}>
          {name}
        </Select.Option>
      ))}
    </PbrSelect>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/SelectOfficer/SelectOfficer.tsx